import { FC } from "react";
import cn from "classnames";
import { FieldError, FieldErrorsImpl, Merge, UseFormRegister } from "react-hook-form";

import { shortenAddress } from "@utils/address";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    placeholder: string;
    classNames?: string;
    name: string;
    required?: boolean;
    autoComplete?: string;
    value?: string;
    error?: FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
    register?: UseFormRegister<any>;
    shortenAddress?: boolean;
}

const MemeInput: FC<Props> = ({
    classNames,
    error = false,
    register = () => {},
    required = false,
    max,
    min,
    shortenAddress: shorten = false,
    value,
    ...props
}) => {
    // Only display shortened value, but use the real value for form submission
    const displayValue = shorten && typeof value === "string" ? shortenAddress(value) : value;

    return (
        <input
            {...register(props.name, { required, max, min })}
            {...props}
            value={displayValue}
            className={cn(
                "text-xs w-full rounded-full border border-muted-foreground bg-input px-3 h-12 py-[14px] !text-gray-500 outline-none placeholder-gray-400",
                "focus:border-primary",
                { "border-primary": value },
                { "!border-orange-500": error },
                classNames,
            )}
            spellCheck={false}
            autoCorrect="off"
        />
    );
};

export default MemeInput;
